// console.log('Seal Price Sync Loaded');

(function () {

  function syncSealPriceToHorizon() {

    const sealPrice = document.querySelector(
      '.sls-option-container.sls-active .sls-price .seal-money'
    );

    const horizonPrice = document.querySelector(
      'product-price .price__regular .price'
    );

    if (!sealPrice || !horizonPrice) return;

    let price = sealPrice.textContent.trim();

    // Convert Seal format (€47.90) to Horizon format (€47,90)
    price = price.replace('.', ',');

    if (horizonPrice.textContent.trim() !== price) {
      horizonPrice.textContent = price;
    }
  }

  function initSealPriceSync() {

    const sealContainer = document.querySelector(
      '.sls-purchase-options-container'
    );

    if (!sealContainer) return;

    // Initial sync
    syncSealPriceToHorizon();

    // Watch Seal changes
    const observer = new MutationObserver(() => {
      syncSealPriceToHorizon();
    });

    observer.observe(sealContainer, {
      childList: true,
      subtree: true,
      attributes: true
    });

    // Backup listeners
    document.addEventListener('change', function (e) {

      if (
        e.target.closest('.sls-purchase-options-container')
      ) {

        setTimeout(syncSealPriceToHorizon, 100);

      }

    });

    document.addEventListener('click', function (e) {

      if (
        e.target.closest('.sls-purchase-options-container')
      ) {

        setTimeout(syncSealPriceToHorizon, 100);

      }

    });

  }

  function startSealSync() {

    if (
      document.querySelector('.sls-purchase-options-container')
    ) {

      initSealPriceSync();

      return;

    }

    setTimeout(startSealSync, 500);

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', startSealSync);

  } else {

    startSealSync();

  }

})();